import * as _picasso from './picasso';
import * as _composablepolkadot from './composablepolkadot';
import * as _penumbra from './penumbra';
import * as _cosmoshubicstestnet from './cosmoshubicstestnet';
const ibc = [
    ..._picasso.ibc,
    ..._composablepolkadot.ibc,
    ..._penumbra.ibc,
    ..._cosmoshubicstestnet.ibc
];
export default ibc;
